import $ from 'jquery';

$('a[href="#ucgJoinThePriorityList"]').on('click', function (e) {
	e.preventDefault();
	$('html, body').animate(
		{
			scrollTop: $('#ucgJoinThePriorityList').position().top - 50,
		},
		'slow'
	);
});

$('a[href="/#ucgJoinThePriorityList"]').on('click', function (e) {
	e.preventDefault();
	$('html, body').animate(
		{
			scrollTop: $('#ucgJoinThePriorityList').position().top - 50,
		},
		'slow'
	);
});

$('a[href="#indoorCommunityAmenities"]').on('click', function (e) {
	e.preventDefault();
	console.log('INDOOR');
	$('html, body').animate(
		{
			scrollTop: $('#indoorCommunityAmenities').position().top - 100,
		},
		'slow'
	);
});

$('a[href="#outdoorCommunityAmenities"]').on('click', function (e) {
	e.preventDefault();
	$('html, body').animate(
		{
			scrollTop: $('#outdoorCommunityAmenities').position().top - 100,
		},
		'slow'
	);
});

$('a[href="#apartmentFeatures"]').on('click', function (e) {
	e.preventDefault();
	$('html, body').animate(
		{
			scrollTop: $('#apartmentFeatures').position().top - 100,
		},
		'slow'
	);
});
